<template>
  <div class="wrapper my-8 mx-8">
    <h2 class="mt-12 pt-10">Reports</h2>
    <div class="cell d-flex align-center justify-center pa-5 mt-5">
      <!-- <router-view></router-view> -->
      <v-tabs color="rgb(0,170,221)">
        <v-tab class="text-capitalize">Live data</v-tab>
        <v-tab class="text-capitalize">Calls</v-tab>
        <v-tab class="text-capitalize">Patients' Calls</v-tab>
        <v-tab class="text-capitalize">Doctors' Calls</v-tab>

        <v-tab class="text-capitalize">Platform Status</v-tab>

        <v-tab class="text-capitalize">Unverified Patients</v-tab>
        <v-tab class="text-capitalize">Unverified Doctors</v-tab>
        <v-tab class="text-capitalize">Available Doctors</v-tab>
        <v-tab class="text-capitalize">Prefecture Doctors</v-tab>

        <v-tab-item>
          <Present class="mt-5" />
        </v-tab-item>

        <v-tab-item>
          <Calls class="mt-5" />
        </v-tab-item>

        <v-tab-item>
          <PatientCalls class="mt-5" />
        </v-tab-item>

        <v-tab-item>
          <DoctorCalls class="mt-5" />
        </v-tab-item>

        <v-tab-item>
          <Platform class="mt-5" />
        </v-tab-item>

        <v-tab-item>
          <UnverifiedPatients class="mt-5" />
        </v-tab-item>

        <v-tab-item>
          <UnverifiedDoctors class="mt-5" />
        </v-tab-item>

        <v-tab-item>
          <AvailableDoctors class="mt-5" />
        </v-tab-item>

        <v-tab-item>
          <PrefectureDoctors class="mt-5" />
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import Calls from "./Calls.vue";
import DoctorCalls from "./DoctorCalls.vue";
import PatientCalls from "./PatientCalls.vue";
import Present from "./Present";
import Platform from "./Platform";
import UnverifiedPatients from "./UnverifiedPatients";
import UnverifiedDoctors from "./UnverifiedDoctors";
import AvailableDoctors from './AvailableDoctors'
import PrefectureDoctors from './PrefectureDoctors'
export default {
  components: {
    Present,
    Calls,
    PatientCalls,
    DoctorCalls,
    Platform,
    UnverifiedPatients,
    UnverifiedDoctors,
    AvailableDoctors,
    PrefectureDoctors
  }
};
</script>
